import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container-page py-32 text-center" data-testid="not-found-page">
      <div className="eyebrow mb-4">404</div>
      <h1 className="font-display text-5xl md:text-7xl text-forest-900">Página não encontrada</h1>
      <p className="text-forest-900/70 mt-4 max-w-md mx-auto">A página que você procura não existe ou foi movida.</p>
      <Link to="/" className="btn-primary mt-10 inline-flex">Voltar ao início</Link>
    </div>
  );
}
